import { render } from "./zones.vue?vue&type=template&id=ddeac56c&scoped=true"
import script from "./zones.vue?vue&type=script&lang=js"
export * from "./zones.vue?vue&type=script&lang=js"

import "./zones.vue?vue&type=style&index=0&id=ddeac56c&lang=scss&scoped=true"

import exportComponent from "/builds/secur/secur-v2-cloud/portal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ddeac56c"]])

export default __exports__